import { useLoadableVariation } from '@hackler/react-sdk';

export const HACKLE_HERO_AB_EXPERIMENT_KEY = 97;

/** A = 기존, B = 수익 강조, C = 쉬움 강조 */
export const useHeroAbExperiment = () => {
  const { variation, isLoading } = useLoadableVariation(HACKLE_HERO_AB_EXPERIMENT_KEY);

  return {
    isA: variation === 'A' || !variation,
    isB: variation === 'B',
    isC: variation === 'C',
    isLoading,
  };
};
